module.exports = __webpack_public_path__ + "img/cases.d0b83ad5.png";